export default { sha: 'c05d8149ccf3a96fc11d206927f310809d32e929', buildNumber: 'undefined' }
